import { type IconProps, HowItWorksIcon } from './HowItWorksIcon'

export const HIW4 = (props: IconProps) => (
  <HowItWorksIcon name='hiw4' {...props} />
)
